import { Component, Input } from '@angular/core';
export type ButtonTypes = 'primary' | 'secondary' | 'ghost' | 'danger';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
  @Input({ required: true }) text: string;

  @Input() buttonType: ButtonTypes = 'primary';

  @Input() fullWidth: boolean = false;

  @Input() disabled: boolean = false;

  @Input() isBtnSmall: boolean = false;
}
